<template>
  <div class="wrapper">
    <a name="pagetop" id="pagetop" class="sr">ページの先頭</a>
    <header class="header">
      <div class="header-top">
        <div class="inner">
          <div class="header-left">
            <p class="site-title">
              <img
                src="@/assets/images/TDSDC/logo_tatsuzin.png"
                width="88"
                height="21"
                alt="TATSUZIN"
              />
            </p>
          </div>
        </div>
      </div>
    </header>
    <br />
    <!-- ****  メッセージ表示領域 **** -->
    <div class="inner-errMsg">
      <p class="errMsg aligncenter newline" style="color: black">
        {{ errMsg }}
      </p>
      <p
        v-if="!isMaintenance && errorMSG"
        class="errMsg aligncenter newline"
        style="color: black"
      >
        {{ errorMSG }}
      </p>
      <p
        v-if="toRedirectUrl && !isMaintenance"
        class="errMsg aligncenter newline"
        style="color: black"
      >
        ご利用元のサービスへ戻ってください
      </p>
      <p
        v-if="isMaintenance || !toRedirectUrl"
        class="errMsg aligncenter newline"
        style="color: black"
      >
        タブの閉じる（×）を利用してください。
      </p>
    </div>
    <div
      v-if="toRedirectUrl && !isMaintenance"
      class="inner-errMsg-btn"
      style="text-align: center"
    >
      <button
        class="frm-btn strong large"
        type="button"
        style="width: 100%"
        @click="handleReturn"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>
  
<script>
import Common from "@/util/common.js";
export default {
  name: "STDSCM04C06VariousErrors",
  data() {
    return {
      //oidc error line-1
      errMsg: "",
      //oidc error line-2
      errorMSG: "",
      errorCD: "",
      buttonText: "ご利用元のサービスへ戻る",
      toRedirectUrl: "",
    };
  },
  computed: {
    isMaintenance() {
      return this.errorCD == "MTFM0992" || this.errorCD == "MTFM0993"
        ? true
        : false;
    },
  },
  created() {
    this.errorCD =
      history.state && history.state.errorCD ? history.state.errorCD : "";
    this.errMsg =
      history.state && history.state.message ? history.state.message : "";
    this.errorMSG =
      history.state && history.state.errorMSG ? history.state.errorMSG : "";
    this.toRedirectUrl = sessionStorage.getItem("toRedirectUrl") || "";

    if(this.errMsg == this.errorMSG){
      this.errorMSG = ""
    }

  },
  methods: {
    handleReturn() {
      window.location.href = this.toRedirectUrl;
    },
  },
};
</script>
  
<style scoped>
p {
  display: flex;
  justify-content: center;
}
@media screen and (max-width: 1280px) {
  .inner-errMsg-btn {
    margin: 15px auto;
    max-width: 320px;
    min-width: 320px;
  }

  .inner {
    margin: 0 auto;
    max-width: unset;
    min-width: unset;
  }

  .inner-errMsg {
    margin: 0px auto;
    padding-top: 85px;
    max-width: 320px;
    min-width: 320px;
  }
}
</style>
  